import { IconBase } from './IconBase'

type IconCloudProps = React.ComponentProps<'svg'>

export const IconCloud = (props: IconCloudProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M9.6 3.84c-3.101 0-5.584 2.452-5.715 5.52C1.641 9.973 0 11.998 0 14.4c0 2.902 2.377 5.28 5.28 5.28h14.4A4.336 4.336 0 0 0 24 15.36c0-1.871-1.247-3.46-2.925-4.02-.101-2.814-2.398-5.1-5.235-5.1-.499 0-.964.124-1.425.255-1.031-1.57-2.79-2.655-4.815-2.655Zm0 .96c1.789 0 3.356 1.005 4.185 2.445l.21.345.375-.135a4.33 4.33 0 0 1 5.79 4.065v.525l.375.09c1.408.332 2.505 1.674 2.505 3.225 0 1.85-1.51 3.36-3.36 3.36H5.28A4.33 4.33 0 0 1 .96 14.4c0-2.078 1.468-3.842 3.45-4.23l.39-.075V9.6c0-2.672 2.128-4.8 4.8-4.8ZM12 8.925l-.345.33-2.88 2.88.69.69 2.055-2.055v5.55h.96v-5.55l2.055 2.055.69-.69-2.88-2.88-.345-.33Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </IconBase>
  )
}
